<template>
  <div>
    <bottom-bar-menu-modal
      class="menupopup"
      v-if="showDropDown"
      @close-menu-modal="toggleShowDropDown()"
      :showModal="showDropDown"
      :menuModalDim="modalDim"
    ></bottom-bar-menu-modal>
    <div
      :class="[
        cartQuantity > 0 ? 'bottom-128' : '',
        showDropDown
          ? 'categories-floating-close-button'
          : 'categories-floating-button',
      ]"
      @click="toggleShowDropDown"
    >
      <i class="hkfi-close-thin fs-24 bold" v-if="showDropDown"></i>
      <i class="hkfi-category-2 fs-24 bold" v-else></i>
      <span class="fs-14 color-white pr2" v-if="showExpanded && !showDropDown"
        >Categories</span
      >
    </div>
  </div>
</template>
<script>
import BottomBarMenuModal from "./BottomBarMenuModal.vue";
import debounce from "lodash/debounce";
import { keyMapsGetter } from "../helpers/storeKeys";
import { EVENT_MENU_CATEGORY_FLOATER } from "../helpers/analyticsEvents";
export default {
  name: "CategoriesFloatingButton",
  components: {
    BottomBarMenuModal,
  },
  data() {
    return {
      showExpanded: true,
      showDropDown: false,
    };
  },
  mounted() {
    window.addEventListener(
      "scroll",
      debounce(this.handleScrollEventListener, 10),
    );
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScrollEventListener);
  },
  methods: {
    toggleShowExpanded() {
      this.showExpanded = !this.showExpanded;
    },
    toggleShowDropDown() {
      if (this.showDropDown) {
        const modal = document.querySelector(".menupopup");
        modal?.classList?.add("closing");
        setTimeout(() => {
          this.showDropDown = !this.showDropDown;
        }, 500);
      } else {
        this.showDropDown = !this.showDropDown;
      }
      EVENT_MENU_CATEGORY_FLOATER({
        userAction: "clicked floater",
        sectionName: "menu category floater",
      });
    },
    handleScrollEventListener() {
      this.showExpanded = window.pageYOffset === 0;
    },
  },
  computed: {
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
    categories() {
      return this.$store.state.ProductItems.productCategory;
    },
    modalDim() {
      return {
        width: "255px",
        height: "fit-content",
        bottom: this.cartQuantity > 0 ? "185px" : "125px",
        maxHeight: "244px",
        modalClass: "categories-menu-modal",
        padding: "0px !important",
      };
    },
  },
};
</script>

<style></style>
